import http from "@/services/http";

/**
 * Lista os objetivos principais do paciente (tabela patient_main_goals).
 * @param {number|string} patientId
 * @returns {Promise<object[]>}
 */
export async function getMainGoalsByPatient(patientId) {
  const { data } = await http.get(
    `/api/patient-main-goals/get-by-patient/${patientId}`,
  );
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Catálogo de objetivos (referência) — alimenta o picker.
 * @returns {Promise<Array<{id:number, name:string, snomed_code:string|null}>>}
 */
export async function getMainGoalCatalog() {
  const { data } = await http.get("/api/main-goal-catalog");
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Adiciona um ou vários objetivos de uma vez.
 * @param {number|string} patientId
 * @param {object[]} goals `[{ goal, main_goal_catalog_id?, notes? }]`
 */
export function createMainGoals(patientId, goals) {
  return http.post("/api/patient-main-goals/create", {
    patient_id: patientId,
    goals: goals.map((g) => ({
      goal: g.goal,
      main_goal_catalog_id: g.main_goal_catalog_id || null,
      notes: g.notes || null,
    })),
  });
}

/**
 * Remove um objetivo (soft delete).
 * @param {number} id
 */
export function deleteMainGoal(id) {
  return http.delete(`/api/patient-main-goals/delete/${id}`);
}
